(() => {
  'use strict';

  customElements.define(
    'one-logos-component',
    class extends HTMLElement {
      constructor() {
        super();
        this.autoplayEnabled = this.getAttribute('data-autoplay') === 'true';
        this.autoplaySpeed =
          parseInt(this.getAttribute('data-autoplay-speed') || '4') * 1000;
        this.autoplayTimer = null;
        this.flkty = null;
        this.logoSlides = null;
      }

      connectedCallback() {
        this.init();
      }

      init() {
        this.slideshowNav = this.querySelector('[data-slider-logos]');
        this.slideshowText = this.querySelector('[data-slider-text]');

        if (this.slideshowNav) {
          this.logoSlides = this.slideshowNav.querySelectorAll('[data-slide]');

          // Initialize text slideshow (always needed)
          this.initSlideshowText();

          // Set up click handlers
          this.bindEvents();

          // For autoplay sections, never use Flickity nav - always use desktop layout
          if (this.autoplayEnabled) {
            this.setupDesktopMode();
            this.setupVisibilityObserver();
          } else {
            // For non-autoplay sections, use original responsive behavior
            this.setupResponsiveMode();
          }
        }
      }

      setupDesktopMode() {
        // Force desktop layout - no Flickity on nav slider
        this.logoSlides.forEach((slide, index) => {
          slide.classList.remove('is-selected');
          if (index === 0) {
            slide.classList.add('is-selected');
          }
        });

        // Start autoplay
        this.bindAutoplayEvents();
        this.startAutoplay();
      }

      setupResponsiveMode() {
        // Original responsive behavior would go here
        // For now, just basic desktop setup
        this.logoSlides.forEach((slide, index) => {
          slide.classList.remove('is-selected');
          if (index === 0) {
            slide.classList.add('is-selected');
          }
        });
      }

      bindEvents() {
        // Handle logo clicks
        this.logoSlides.forEach((slide) => {
          slide.addEventListener('click', () => {
            const slideIndex = parseInt(slide.getAttribute('data-slide-index'));

            // Update text slideshow
            if (this.flkty) {
              this.flkty.select(slideIndex);
            }

            // Update nav selection (desktop mode)
            this.logoSlides.forEach((s) => s.classList.remove('is-selected'));
            slide.classList.add('is-selected');

            // Scroll slide into center view
            this.scrollSlideIntoView(slide);

            // Restart autoplay after interaction (shorter delay)
            if (this.autoplayEnabled) {
              this.stopAutoplay();
              this.startAutoplay();
            }
          });
        });
      }

      bindAutoplayEvents() {
        this.addEventListener('mouseenter', () => this.stopAutoplay());
        this.addEventListener('mouseleave', () => this.startAutoplay());
      }

      setupVisibilityObserver() {
        const observer = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              if (entry.isIntersecting) {
                // Section came into view, start autoplay
                this.startAutoplay();
              } else {
                // Section left view, stop autoplay
                this.stopAutoplay();
              }
            });
          },
          { threshold: 0.1 } // Trigger when at least 10% is visible
        );

        observer.observe(this.slideshowNav);
        this.visibilityObserver = observer;
      }

      scrollSlideIntoView(slide) {
        const containerWidth = this.slideshowNav.offsetWidth;
        const slideLeft = slide.offsetLeft;
        const slideWidth = slide.offsetWidth;
        
        // Center the slide in the container
        const scrollLeft = slideLeft - (containerWidth - slideWidth) / 2;
        
        this.slideshowNav.scrollTo({
          left: scrollLeft,
          behavior: 'smooth'
        });
      }

      initSlideshowText() {
        if (this.slideshowText) {
          this.flkty = new window.theme.FlickityFade(this.slideshowText, {
            fade: true,
            autoPlay: false,
            prevNextButtons: false,
            cellAlign: 'left',
            contain: true,
            pageDots: false,
            wrapAround: false,
            selectedAttraction: 0.2,
            friction: 0.6,
            draggable: false,
            accessibility: false,
          });
        }
      }

      startAutoplay() {
        if (!this.autoplayEnabled || this.autoplayTimer) return;

        this.autoplayTimer = setInterval(() => {
          const currentSlide = this.slideshowNav.querySelector('.is-selected');
          if (currentSlide && this.logoSlides.length > 1) {
            const currentIndex = parseInt(
              currentSlide.getAttribute('data-slide-index')
            );
            const nextIndex = (currentIndex + 1) % this.logoSlides.length;
            this.logoSlides[nextIndex].click();
          }
        }, this.autoplaySpeed);
      }

      stopAutoplay() {
        if (this.autoplayTimer) {
          clearInterval(this.autoplayTimer);
          this.autoplayTimer = null;
        }
      }

      disconnectedCallback() {
        this.stopAutoplay();

        if (this.visibilityObserver) {
          this.visibilityObserver.disconnect();
        }

        if (this.flkty) {
          this.flkty.destroy();
        }
      }
    }
  );
})();
